<!-- Create a template for the content of the <app-mat-tab> so that we can grab a reference to this
    TemplateRef and use it in a Portal to render the tab content in the appropriate place in the
    tab-group. -->
<ng-template><ng-content></ng-content></ng-template>
